import { Outlet } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import { useEffect, useState } from "react";

import { useProfile } from "@/hooks/server-state/use-profile";

import ProfileHeader from "./_components/profile-header";
import ProfileNavbar from "./_components/profile-navbar";

const EditProfilePage = () => {
  const { data: profileData, isLoading, error, isError, status, fetchStatus } = useProfile();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Debug logging
  console.log('EditProfilePage Debug:', {
    profileData,
    isLoading,
    error,
    isError,
    status,
    fetchStatus,
    hasData: !!profileData,
    mounted
  });

  // Wait for component to mount
  if (!mounted) {
    console.log('EditProfilePage: Component not mounted yet');
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <MoonLoader color="#0099A5" size={50} />
      </div>
    );
  }

  // Handle loading state at the parent level
  if (isLoading || status === 'pending') {
    console.log('EditProfilePage: Showing loading state');
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <MoonLoader color="#0099A5" size={50} />
      </div>
    );
  }

  // Handle error state
  if (isError || error) {
    console.log('EditProfilePage: Showing error state', error);
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <div className="text-center">
          <p className="text-red-500">خطا در بارگذاری اطلاعات پروفایل</p>
          <p className="text-sm text-gray-500 mt-2">لطفاً دوباره تلاش کنید</p>
          <p className="text-xs text-gray-400 mt-1">
            Error: {error?.message || 'Unknown error'}
          </p>
        </div>
      </div>
    );
  }

  // Only render when we have profile data
  if (!profileData || status !== 'success') {
    console.log('EditProfilePage: No profile data available or not success status');
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <div className="text-center">
          <p className="text-gray-500">اطلاعات پروفایل موجود نیست</p>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
          >
            تلاش مجدد
          </button>
        </div>
      </div>
    );
  }

  console.log('EditProfilePage: Rendering main content');
  return (
    <section>
      <ProfileNavbar />
      <ProfileHeader />
      <div className="relative py-5">
        <Outlet />
      </div>
    </section>
  );
};
export default EditProfilePage;
